import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    // School Projects
    {
      id: 1,
      title: "Issue Tracker",
      description: "A ReactJS front-end site using NodeJS and ExpressJS on the back end to manage issue reports and account information, including BCrypt to encrypted passwords for storage on a MongoDB database.",
      technologies: ["React", "Node.js", "Express.js", "MongoDB", "BCrypt"],
      githubUrl: "https://github.com/JacobWeinrich/IssueTracker-FinalProject/tree/main",
      liveUrl: "https://issuetracker-demo.jakeweinrich.com/",
      image: "warning-triangle",
      category: "School Projects",
      subcategory: "Full-Stack",
      learnMore: {
        title: "🐛 Issue Tracker - Full-Stack Bug Management System",
        description: "A comprehensive full-stack web application for bug tracking and project management. Built with React frontend and Node.js/Express backend, featuring real-time communication, role-based authentication, and advanced bug management capabilities.",
        features: [
          "Full-stack React and Node.js application",
          "MongoDB database with connection pooling",
          "JWT authentication with role-based access control",
          "Real-time chat system with Socket.io",
          "Advanced bug tracking and management",
          "User management with admin controls",
          "Comment system for bug discussions",
          "Test case management and tracking",
          "Search and filtering capabilities",
          "Responsive Material-UI design"
        ],
        background: "Developed as a school project to demonstrate full-stack web development skills. The application showcases modern JavaScript frameworks, database design, authentication systems, and real-time communication features.",
        technicalDetails: "Built with React 18, Node.js/Express.js, MongoDB, Socket.io for real-time features, JWT authentication, and Material-UI components. Implements RESTful API design, comprehensive security measures, and production-ready deployment configuration."
      }
    },
    {
      id: 2,
      title: "LaundroDrop",
      description: "An order management system for laundromats with a laundry drop-off and pick-up service using a C# Windows Form App for the user interface and SQL for storage of Customer and Order information. This school project has been developed into a professional .NET MAUI application.",
      technologies: ["C#", "WinForms", "SQL", "Windows Forms"],
      githubUrl: "https://github.com/JacobWeinrich/laundrodrop",
      liveUrl: null,
      image: "laundry-shirt",
      category: "School Projects",
      subcategory: "Desktop Application",
      hasNewVersion: true,
      newVersionId: 6,
      learnMore: {
        title: "🧺 LaundroDrop - Laundromat Order Management System",
        description: "A desktop application built for laundromat operations, providing order management capabilities for laundry drop-off and pick-up services. This school project served as the foundation for the professional LaundroDrop 2.0 application.",
        features: [
          "C# Windows Forms application for desktop use",
          "SQL database for customer and order information storage",
          "Order management system for laundry services",
          "Customer information tracking and management",
          "Drop-off and pick-up service coordination",
          "User-friendly Windows Forms interface"
        ],
        background: "Developed as a school project to demonstrate desktop application development skills using C# and Windows Forms. The application manages customer orders and information for laundromat operations, providing a practical solution for small business needs.",
        technicalDetails: "Built with C# and Windows Forms for the user interface, with SQL Server for database storage. The application demonstrates desktop application development principles, database design, and user interface design for business applications."
      }
    },
    {
      id: 3,
      title: "Law Day Run Website",
      description: "A midterm project built for a charity marathon group that needed an updated website with modern design and functionality.",
      technologies: ["HTML", "CSS", "JavaScript"],
      githubUrl: "https://github.com/JacobWeinrich/Law-Day-Run-Midterm",
      liveUrl: "https://lawdayrun-midterm.jakeweinrich.com/index.html",
      image: "running-person",
      category: "School Projects",
      subcategory: "Frontend"
    },
    {
      id: 4,
      title: "Sports Pro",
      description: "An ASP.Net Core MVC project that uses SQL Databases to store different data ranging from Customer Information, Products, and Incident Reports.",
      technologies: ["C#", "ASP.NET Core MVC", "SQL", "MVC"],
      githubUrl: "https://github.com/JacobWeinrich/Sports-Pro-FinalProject",
      liveUrl: "http://segshark-001-site2.rtempurl.com/",
      image: "sports-ball",
      category: "School Projects",
      subcategory: "Web Application",
      learnMore: {
        title: "🏆 SportsPro Technical Support System",
        description: "A comprehensive ASP.NET Core MVC web application for sports equipment technical support management. Features role-based authentication, incident tracking, customer management, and technician assignment systems with modern responsive design.",
        liveDemo: {
          url: "http://segshark-001-site2.rtempurl.com/",
          note: "This is the default admin account and can grant admin to other accounts"
        },
        features: [
          "Role-based authentication with admin and user access levels",
          "Comprehensive user management with privilege control",
          "Product catalog with full CRUD operations",
          "Customer database with multi-country support",
          "Technician management and assignment system",
          "Incident tracking and status management",
          "Product registration linking customers to products",
          "Responsive Bootstrap UI with FontAwesome icons",
          "Secure session management and authorization",
          "Admin dashboard with comprehensive management tools"
        ],
        background: "Developed as a school project to demonstrate full-stack web development skills using ASP.NET Core MVC. The application simulates a real-world technical support system for sports equipment companies, showcasing modern web development practices and user experience design.",
        technicalDetails: "Built with ASP.NET Core MVC framework, Entity Framework Core for database operations, ASP.NET Identity for authentication, and Bootstrap for responsive UI. Implements repository pattern for clean data access architecture and role-based security throughout the application."
      }
    },
    // Personal/Freelancing Projects
    {
      id: 5,
      title: "Portfolio Website",
      description: "A modern, responsive portfolio website built with React and featuring dark/light mode, smooth animations, and mobile-first design.",
      technologies: ["React", "JavaScript", "CSS3", "HTML5", "Responsive Design"],
      githubUrl: "https://github.com/JacobWeinrich/portfolio",
      liveUrl: "https://jakeweinrich.com",
      image: "portfolio-briefcase",
      image: "portfolio-briefcase",
      category: "Personal/Freelancing Projects",
      subcategory: "Personal Project"
    },

    {
      id: 6,
      title: "LaundroDrop 2.0",
      description: "Professional .NET MAUI application for laundromat POS system. Features include SQLite database, invoice/receipt printing with printer selection, employee login system, comprehensive audit logs, order management with orderlines (Wash Dry Fold, Dry Cleaning, Commercial), customer management, payment processing (Credit Card/Cash/Check/Billable), partial payment tracking, and advanced search functionality for orders and audit logs.",
      technologies: [".NET MAUI", "C#", "SQLite", "Windows", "POS System", "Printing", "Audit Logs"],
      githubUrl: "https://github.com/JacobWeinrich/laundrodrop-2.0",
      liveUrl: null,
      image: "laundry-shirt",
      image: "laundry-shirt",
      category: "Personal/Freelancing Projects",
      subcategory: "Desktop Application",
      isPrized: true,
      status: "Work In Progress",
      learnMore: {
        title: "LaundroDrop 2.0 - Professional Laundromat POS System",
        description: "A comprehensive Point of Sale system specifically designed for laundromat Wash Dry Fold services, replacing the complexity of QuickBooks with a focused, user-friendly solution.",
        videoUrl: "/videos/laundrodrop-demo.mp4", // Local video file
        features: [
          "SQLite database for reliable data storage",
          "Invoice and receipt printing with computer printer selection",
          "Employee login system with role-based access",
          "Comprehensive audit logs tracking all changes",
          "Order management with orderlines (Wash Dry Fold, Dry Cleaning, Commercial)",
          "Customer management with easy search functionality",
          "Payment processing (Credit Card, Cash, Check, Billable)",
          "Partial payment tracking - orders can't be completed until fully paid",
          "Advanced search for orders by date range, customer, totals, and items",
          "Audit log search by date ranges and employee actions"
        ],
        background: "Developed for family laundromat business to replace QuickBooks complexity with a focused solution for Wash Dry Fold services. The app streamlines operations while maintaining detailed records for business management.",
        technicalDetails: "Built with .NET MAUI for Windows, using SQLite for data persistence, and implementing comprehensive business logic for order processing, payment tracking, and audit logging.",
        coreBusinessFeatures: {
          orderManagement: [
            "Create, edit, and track laundry orders with real-time status updates",
            "Order search and filtering capabilities",
            "Support for multiple order types (Normal, Commercial, Dry Cleaning)",
            "Order notes and customer association",
            "Real-time order status tracking with completion dates"
          ],
          customerManagement: [
            "Customer search by name or phone number",
            "Customer creation and editing with comprehensive profiles",
            "Customer history tracking and order history",
            "Special instructions and notes per customer",
            "Commercial vs. residential customer classification"
          ],
          itemServiceManagement: [
            "Dynamic item catalog with pricing and categories",
            "Support for by-pound and by-piece pricing models",
            "Item classification (commercial, dry cleaning, taxable status)",
            "Tax rate configuration per item or global settings",
            "Active/inactive item status management"
          ],
          paymentProcessing: {
            multiPaymentSupport: [
              "Credit/Debit card processing",
              "Cash payment handling",
              "Check payment with check number tracking",
              "Billable account support",
              "Partial payment processing with balance tracking"
            ],
            paymentManagement: [
              "Real-time payment status tracking (Awaiting, Partial, Paid in Full)",
              "Payment line item tracking with reference numbers",
              "Payment history and audit trails",
              "Automatic payment status updates"
            ]
          },
          printingReceiptSystem: {
            advancedPrinting: [
              "Multi-printer support with automatic printer detection",
              "Custom receipt templates with company branding",
              "Invoice printing with detailed item breakdowns",
              "Bag tags and dry cleaning tags with barcode support",
              "PDF receipt generation and storage"
            ],
            receiptCustomization: [
              "Company logo and branding integration",
              "Customizable receipt layouts",
              "Tax calculation display",
              "Customer information integration",
              "Order notes and special instructions"
            ]
          }
        },
        administrativeFeatures: {
          employeeManagement: [
            "Employee role-based access control",
            "Employee account creation and management",
            "Active/inactive employee status",
            "Employee audit trails and activity logging"
          ],
          settingsManagement: [
            "Company information configuration",
            "Tax rate settings and customization",
            "Business hours configuration",
            "Default settings management"
          ]
        },
        dataManagementSecurity: {
          auditSystem: [
            "Complete audit trail for all data changes",
            "User activity tracking and logging",
            "Field-level change tracking with before/after values",
            "Audit log viewer with filtering and search",
            "Parent-child relationship tracking for complex operations"
          ],
          backupRecovery: [
            "Automated backup scheduling with configurable intervals",
            "Manual backup and restore functionality",
            "Backup progress tracking with visual indicators",
            "Backup location management and validation",
            "Idle-time backup execution to minimize disruption"
          ]
        },
        technicalArchitecture: {
          modernFramework: [
            "Cross-platform compatibility (Windows, Android, iOS, macOS)",
            "MVVM architecture pattern implementation",
            "XAML-based responsive UI design",
            "Dark theme support with modern styling"
          ],
          databaseManagement: [
            "SQLite database with Entity Framework Core",
            "Comprehensive data models with relationships",
            "Database migration system for schema updates",
            "Performance-optimized queries with indexing",
            "Data validation and integrity constraints"
          ],
          realTimeFeatures: [
            "Live order status updates",
            "Real-time payment calculations",
            "Dynamic tax calculations",
            "Instant search results",
            "Real-time backup progress tracking"
          ]
        },
        communicationNotifications: {
          smsIntegration: [
            "Twilio SMS service integration",
            "Automated pickup notifications",
            "Customizable message templates",
            "Company hours integration in notifications",
            "Customer contact management"
          ],
          userInterfaceEnhancements: [
            "Toast notifications for system events",
            "Progress overlays for long-running operations",
            "Unsaved changes warnings and protection",
            "Keyboard shortcuts for power users",
            "Responsive design for various screen sizes"
          ]
        },
        advancedFeatures: {
          orderCaching: [
            "Intelligent order caching to improve performance",
            "Cache invalidation and refresh mechanisms",
            "Memory-efficient data management",
            "Background data synchronization"
          ],
          searchFiltering: [
            "Advanced order search with multiple criteria",
            "Customer search with real-time results",
            "Item search with pricing display",
            "Date range filtering and sorting"
          ],
          dataExportReporting: [
            "Order history export capabilities",
            "Customer data export functionality",
            "Payment history reporting",
            "Audit log export and analysis"
          ]
        }
      }
    },
    {
      id: 7,
      title: "Weinrich Construction",
      description: "A website for a small business construction company built during my first semester of college using HTML, CSS, and JavaScript. Features modern design and responsive layout for a professional construction business.",
      technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
      githubUrl: null,
      liveUrl: "https://weinrichconstructionstl.com/",
      image: "construction-icon",
      category: "Personal/Freelancing Projects",
      subcategory: "Freelance Project"
    },
    {
      id: 8,
      title: "Minecraft Forge 1.20.1 Bounty Mod",
      description: "A Java mod for Minecraft Forge 1.20.1 that allows players on PVP multiplayer servers to place bounties on other players. Developed for a public server to add incentive for player battles.",
      technologies: ["Java", "Minecraft Forge", "JSON", "Minecraft Modding"],
      githubUrl: "https://github.com/JacobWeinrich/Jakes-Bounty-Mod",
      liveUrl: null,
      image: "minecraft-icon",
      category: "Personal/Freelancing Projects",
      subcategory: "Game Development"
    },
    {
      id: 9,
      title: "Twin City Coin Laundry",
      description: "Freelance website for Twin City Coin Laundry featuring modern design and responsive layout. Includes business hours, services (self-service laundry, wash dry fold, dry cleaning drop-off), facility information, and contact details.",
      technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
      githubUrl: null,
      liveUrl: "https://www.segotw.com/laundries/twincitycoinlaundry/",
      image: "laundry-icon",
      category: "Personal/Freelancing Projects",
      subcategory: "Freelance Project"
    },
    {
      id: 10,
      title: "Sudsy's Coin Laundry",
      description: "Freelance website for Sudsy's Coin Laundry featuring modern design and responsive layout. Includes business hours, services (self-service laundry, wash dry fold, dry cleaning drop-off, ironing), facility information, and contact details.",
      technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
      githubUrl: null,
      liveUrl: "https://sudsyslaundromat.com/",
      image: "laundry-icon",
      category: "Personal/Freelancing Projects",
      subcategory: "Freelance Project"
    },
    {
      id: 11,
      title: "House Springs Coin Laundry",
      description: "Freelance website for House Springs Coin Laundry featuring modern design and responsive layout. Includes business hours, services (self-service laundry, wash dry fold, dry cleaning drop-off), facility information, and contact details.",
      technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
      githubUrl: null,
      liveUrl: "http://housespringscoinlaundry.com/",
      image: "laundry-icon",
      category: "Personal/Freelancing Projects",
      subcategory: "Freelance Project"
    },
    {
      id: 12,
      title: "InterState Coin Laundry",
      description: "Freelance website made for a customer of System Engineering Group. Features modern design and responsive layout for a professional laundromat business.",
      technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
      githubUrl: null,
      liveUrl: "https://interstatecoinlaundry.com/",
      image: "laundry-icon",
      category: "Personal/Freelancing Projects",
      subcategory: "Freelance Project"
    },
    {
      id: 13,
      title: "One Call Services STL",
      description: "Freelance website for One Call Services STL. Features modern design and responsive layout for a professional handyman and construction business.",
      technologies: ["HTML", "CSS", "JavaScript", "Responsive Design"],
      githubUrl: null,
      liveUrl: "https://onecallservicesstl.com/",
      image: "construction-icon",
      category: "Personal/Freelancing Projects",
      subcategory: "Freelance Project"
    }
  ];

  const categories = ["All", "School Projects", "Personal/Freelancing Projects"];
  const [selectedCategory, setSelectedCategory] = React.useState("All");
  const [expandedProject, setExpandedProject] = React.useState(null);
  const [highlightedProject, setHighlightedProject] = React.useState(null);

  const scrollToNewVersion = (newVersionId) => {
    // Set category to "All" to ensure the target project is visible
    setSelectedCategory("All");

    // Wait a bit for the filter to update, then scroll
    setTimeout(() => {
      const targetProject = document.querySelector(`[data-project-id="${newVersionId}"]`);
      if (targetProject) {
        // Calculate scroll position with offset for navbar
        const navbar = document.querySelector('.navbar');
        const navbarHeight = navbar ? navbar.offsetHeight : 80;
        const elementTop = targetProject.offsetTop - navbarHeight - 20;

        window.scrollTo({
          top: elementTop,
          behavior: 'smooth'
        });

        // Highlight the target project
        setHighlightedProject(newVersionId);
        setTimeout(() => {
          setHighlightedProject(null);
        }, 3000);
      }
    }, 100);
  };

  const filteredProjects = selectedCategory === "All"
    ? projects.sort((a, b) => {
      // Show prized projects first, then Personal/Freelancing Projects, then School Projects
      if (a.isPrized && !b.isPrized) return -1;
      if (!a.isPrized && b.isPrized) return 1;
      if (a.category === "Personal/Freelancing Projects" && b.category === "School Projects") return -1;
      if (a.category === "School Projects" && b.category === "Personal/Freelancing Projects") return 1;

      // Within Personal/Freelancing Projects, prioritize laundry sites after LaundroDrop 2.0
      if (a.category === "Personal/Freelancing Projects" && b.category === "Personal/Freelancing Projects") {
        // LaundroDrop 2.0 (id: 6) should be first
        if (a.id === 6) return -1;
        if (b.id === 6) return 1;

        // Then laundry sites (ids: 9, 10, 11, 12)
        const laundryIds = [9, 10, 11, 12];
        const aIsLaundry = laundryIds.includes(a.id);
        const bIsLaundry = laundryIds.includes(b.id);

        if (aIsLaundry && !bIsLaundry) return -1;
        if (!aIsLaundry && bIsLaundry) return 1;

        // Within laundry sites, sort by ID
        if (aIsLaundry && bIsLaundry) {
          return a.id - b.id;
        }
      }

      return a.id - b.id;
    })
    : projects.filter(project => project.category === selectedCategory);

  return (
    <div className="projects">
      <div className="container">
        <section className="projects-hero">
          <h1 className="section-title">My Projects</h1>
          <p className="projects-intro">
            Here are some of the projects I've worked on. Each project demonstrates different
            aspects of my skills and experience in software development.
          </p>
        </section>

        <section className="projects-filter">
          <div className="filter-buttons">
            {categories.map(category => (
              <button
                key={category}
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </section>

        <section className="projects-grid">
          {filteredProjects.map(project => (
            <div
              key={project.id}
              className={`project-card ${project.isPrized ? 'prized-project' : ''} ${highlightedProject === project.id ? 'highlight-project' : ''}`}
              data-project-id={project.id}
            >
              {project.isPrized && (
                <div className="star-badge" title="This is an important project that will be used in the real world!">
                  ★
                </div>
              )}
              <div className="project-image">
                {project.image === "warning-triangle" ? (
                  <svg className="project-icon custom-svg" viewBox="0 0 382.275 382.275" fill="none">
                    <path d="M175.466,84.275c0-4.971,4.029-9,9-9h10.001c4.971,0,9,4.029,9,9s-4.029,9-9,9h-10.001 C179.496,93.275,175.466,89.246,175.466,84.275z M204.009,204.002c12.328,0.96,24.51,6.007,33.263,13.908 c3.69,3.331,9.382,3.04,12.711-0.65c3.331-3.689,3.04-9.16-0.65-12.49c-12.982-11.719-31.524-18.494-49.599-18.494h-1.237 c-3.844,0-7.264,2.221-8.512,5.856c-2.12,6.174-10.586,12.313-22.667,12.313c-12.081,0-20.546-6.083-22.665-12.256 c-1.248-3.636-4.668-5.913-8.513-5.913h-1.239c-30.6,0-59.204,18.84-65.12,43.174L43.354,338.046 c-0.118,0.441-0.204,0.839-0.254,1.304c-0.124,1.12-0.034,2.199,0.241,3.244c0.247,0.938,0.641,1.804,1.156,2.596 c1.071,1.65,2.68,2.948,4.653,3.616c0.292,0.1,0.59,0.18,0.895,0.249c0.673,0.154,1.346,0.226,2.01,0.226 c0.09,0,0.18-0.003,0.27-0.006h54.021c4.971,0,9-4.029,9-9s-4.029-9-9-9H63.498l23.774-97.795 c3.653-15.024,22.955-27.869,43.357-29.477c6.951,11.05,21.07,18.33,36.689,18.33C182.937,222.334,197.058,215.053,204.009,204.002z M159.17,84.275c0-4.971-4.029-9-9-9h-10.001c-4.971,0-9,4.029-9,9s4.029,9,9,9h10.001C155.141,93.275,159.17,89.246,159.17,84.275z M96.296,104.189c2.605,0.43,5.506-0.304,7.523-2.014s3.411-4.221,3.411-6.865V78.087C107.23,44.955,134.065,18,167.197,18 c1.61,0,3.145,0.063,4.723,0.188c-8.34,12.947-20.495,22.306-34.146,26.124c-4.787,1.339-7.597,6.305-6.258,11.092 c1.339,4.786,6.298,7.588,11.084,6.242c19.757-5.526,36.934-19.669,47.566-39.035c21.707,9.067,36.999,30.52,36.999,55.476 c0,25.727-16.182,48.437-40,56.835c-2.833-2.39-6.491-3.647-10.479-3.647h-19.217c-8.971,0-16.27,7.029-16.27,15.999 c0,8.971,7.299,16.001,16.27,16.001h19.217c7.277,0,13.453-4.719,15.526-11.321c23.191-7.843,41.083-25.89,48.827-48.374 c10.454-2.538,17.19-8.972,17.19-16.953V66.679c0-8.283-7.242-14.944-18.385-17.265C228.392,20.501,200.084,0,167.144,0 c-32.981,0-61.509,20.557-72.935,49.527C83.371,51.946,76.23,58.526,76.23,66.679v19.948 C76.23,95.296,84.242,102.189,96.296,104.189z M265.536,327.275h0.453c4.971,0,9-4.029,9-9s-4.029-9-9-9h-0.453 c-4.971,0-9,4.029-9,9S260.565,327.275,265.536,327.275z M329.914,208.275h-41.692c-4.971,0-9,4.029-9,9s4.029,9,9,9h33.009v117.037 c0,4.971,4.029,9,9,9s9-4.029,9-9V216.946C339.23,211.976,334.885,208.275,329.914,208.275z M308.23,373.275c0,4.971-4.029,9-9,9 h-101c-4.971,0-9-4.029-9-9v-126c0-4.971,4.029-9,9-9h101c4.971,0,9,4.029,9,9V373.275z M290.23,256.275h-83v17h28.253 c4.971,0,9,4.029,9,9s-4.029,9-9,9H207.23v18h28.253c4.971,0,9,4.029,9,9s-4.029,9-9,9H207.23v37h83V256.275z M265.536,291.275 h0.453c4.971,0,9-4.029,9-9s-4.029-9-9-9h-0.453c-4.971,0-9,4.029-9,9S260.565,291.275,265.536,291.275z" fill="white" />
                  </svg>
                ) : project.image === "laundry-shirt" ? (
                  <svg className="project-icon custom-svg" viewBox="0 0 507.9 507.9" fill="none">
                    <path d="M437.449,0h-366.8c-23.4,0-42.4,19-42.4,42.3v409.2c0,23.3,19,42.3,42.3,42.3h34.8c0,7.8,6.3,14.1,14.1,14.1h32 c7.8,0,14.1-6.3,14.1-14.1h176.8c0,7.8,6.3,14.1,14.1,14.1h32c7.8,0,14.1-6.3,14.1-14.1h34.8c23.3,0,42.3-19,42.3-42.3V42.3 C479.849,19,460.849,0,437.449,0z M451.549,451.7c0.1,7.6-6.3,14-14.1,14h-366.8c-7.8,0-14.1-6.3-14.1-14.1V255.9h17.7 c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-17.8v-28.2h46c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-46v-35h395.1V451.7 z M451.649,108h-395.2V42.3c0-7.7,6.4-14.1,14.2-14.1h366.9c7.8,0,14.1,6.3,14.1,14.1V108z" fill="white" />
                    <path d="M254.049,171.2c-69.3,0-125.6,56.3-125.6,125.6s56.3,125.6,125.6,125.6s125.6-56.3,125.6-125.6 S323.349,171.2,254.049,171.2z M254.049,394.2c-53.7,0-97.4-43.7-97.4-97.4c0-53.7,43.7-97.4,97.4-97.4s97.4,43.7,97.4,97.4 C351.449,350.5,307.749,394.2,254.049,394.2z" fill="white" />
                    <path d="M254.049,227.7c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1c22.6,0,40.9,18.4,40.9,40.9c0,7.8,6.3,14.1,14.1,14.1 s14.1-6.3,14.1-14.1C323.249,258.7,292.149,227.7,254.049,227.7z" fill="white" />
                    <path d="M130.149,55.3h-31.8c-7.8,0-14.1,6.3-14.1,14.1c0,7.8,6.3,14.1,14.1,14.1h31.8c7.8,0,14.1-6.3,14.1-14.1 C144.249,61.6,137.949,55.3,130.149,55.3z" fill="white" />
                    <path d="M240.049,55.3h-31.8c-7.8,0-14.1,6.3-14.1,14.1c0,7.8,6.3,14.1,14.1,14.1h31.8c7.8,0,14.1-6.3,14.1-14.1 C254.149,61.6,247.849,55.3,240.049,55.3z" fill="white" />
                  </svg>
                ) : project.image === "running-person" ? (
                  <svg className="project-icon custom-svg" viewBox="0 0 18.467 18.467" fill="none">
                    <path d="M17.109,5.454c-0.242-0.289-0.673-0.327-0.962-0.086l-1.894,1.591l-0.871-2.158 c-0.031-0.081-0.078-0.149-0.132-0.209c-0.178-0.396-0.487-0.736-0.913-0.933c-0.185-0.084-0.376-0.129-0.567-0.151 c-0.042-0.022-0.08-0.051-0.128-0.066L8.309,2.513C8.122,2.462,7.934,2.495,7.78,2.585C7.597,2.647,7.44,2.78,7.365,2.973 L6.11,6.2C5.974,6.551,6.148,6.947,6.5,7.085c0.35,0.136,0.747-0.039,0.884-0.391l1.06-2.725l1.518,0.422 c-0.037,0.06-0.077,0.116-0.107,0.18L7.909,8.789C7.881,8.851,7.866,8.914,7.846,8.978l-2.365,3.965l-3.958,1.324 c-0.448,0.335-0.543,0.966-0.212,1.414c0.333,0.449,0.966,0.544,1.413,0.213l4.05-1.395c0.124-0.09,0.214-0.208,0.282-0.335 C7.107,14.11,7.165,14.067,7.204,14l1.41-2.364l2.503,2.133l-2.678,3.018c-0.369,0.416-0.332,1.057,0.086,1.425 c0.417,0.371,1.056,0.332,1.427-0.086l3.342-3.765c0.104-0.116,0.166-0.25,0.208-0.39c0.025-0.076,0.025-0.155,0.031-0.234 c0-0.04,0.015-0.076,0.012-0.113c-0.009-0.276-0.121-0.544-0.347-0.735l-2.303-1.964c0.166-0.158,0.307-0.346,0.409-0.567 l1.492-3.231L13.274,8.4c0.02,0.113,0.058,0.224,0.138,0.317c0.072,0.086,0.164,0.143,0.262,0.183 c0.01,0.005,0.022,0.006,0.034,0.009c0.062,0.022,0.125,0.043,0.19,0.046c0.077,0.007,0.155-0.003,0.234-0.025 c0.002-0.001,0.003-0.001,0.003-0.001c0.021-0.005,0.042-0.001,0.063-0.01c0.111-0.042,0.196-0.113,0.269-0.196l2.718-2.307 C17.474,6.173,17.352,5.743,17.109,5.454z" fill="white" />
                    <circle cx="13.671" cy="1.905" r="1.905" fill="white" />
                  </svg>
                ) : project.image === "sports-ball" ? (
                  <svg className="project-icon custom-svg" viewBox="0 0 24 24" fill="none">
                    <path d="M22.1,1.9C18.664-1.531,9.372-.067,4.652,4.652S-1.531,18.664,1.9,22.1A8.106,8.106,0,0,0,7.667,23.98a17.434,17.434,0,0,0,11.681-4.632C24.066,14.629,25.531,5.336,22.1,1.9ZM16.333,2a6.232,6.232,0,0,1,4.351,1.314C21.7,4.331,22.111,6.3,21.959,8.545l-6.5-6.5C15.754,2.026,16.05,2,16.333,2ZM3.316,20.684C2.3,19.669,1.889,17.7,2.041,15.455l6.5,6.5C6.3,22.11,4.331,21.7,3.316,20.684Zm14.618-2.75a14.685,14.685,0,0,1-6.929,3.657l-8.6-8.6A14.674,14.674,0,0,1,6.066,6.066a14.645,14.645,0,0,1,6.94-3.646l8.586,8.586A14.674,14.674,0,0,1,17.934,17.934Zm-.227-6.227a1,1,0,0,1-1.414,0L15,10.414,13.414,12l1.293,1.293a1,1,0,1,1-1.414,1.414L12,13.414,10.414,15l1.293,1.293a1,1,0,1,1-1.414,1.414l-4-4a1,1,0,0,1,1.414-1.414L9,13.586,10.586,12,9.293,10.707a1,1,0,0,1,1.414-1.414L12,10.586,13.586,9,12.293,7.707a1,1,0,0,1,1.414-1.414l4,4A1,1,0,0,1,17.707,11.707Z" fill="white" />
                  </svg>
                ) : project.image === "portfolio-briefcase" ? (
                  <svg className="project-icon custom-svg" viewBox="0 0 32 32" fill="none">
                    <path d="M26,27H6c-1.1,0-2-0.9-2-2V12c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v13C28,26.1,27.1,27,26,27z" stroke="white" strokeWidth="2" fill="none" />
                    <path d="M22.6,18H9.4c-3,0-5.4-2.4-5.4-5.4V12c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v0.6C28,15.6,25.6,18,22.6,18z" stroke="white" strokeWidth="2" fill="none" />
                    <line x1="10" y1="20" x2="10" y2="18" stroke="white" strokeWidth="2" />
                    <line x1="22" y1="20" x2="22" y2="18" stroke="white" strokeWidth="2" />
                    <path d="M9.3,10c0.9-2.9,3.5-5,6.7-5c3.2,0,5.8,2.1,6.7,5" stroke="white" strokeWidth="2" fill="none" />
                  </svg>
                ) : project.image === "construction-icon" ? (
                  <svg className="project-icon custom-svg" viewBox="0 -0.5 17 17" fill="none">
                    <path d="M15.287,12.025 L13.274,12.025 L12.746,10.025 L3.176,10.025 L2.648,12.025 L0.692,12.025 C0.322,12.025 0.021,12.296 0.021,12.634 L0.021,13.318 C0.021,13.655 0.322,13.927 0.692,13.927 L15.288,13.927 C15.658,13.927 15.959,13.655 15.959,13.318 L15.959,12.634 C15.958,12.297 15.657,12.025 15.287,12.025 L15.287,12.025 Z" fill="white" />
                    <path d="M10.207,0.031 L5.797,0.031 L5.038,2.952 L10.969,2.952 L10.207,0.031 Z" fill="white" />
                    <path d="M11.346,5.004 L4.658,5.004 L4.021,7.955 L11.984,7.955 L11.346,5.004 Z" fill="white" />
                  </svg>
                ) : project.image === "minecraft-icon" ? (
                  <svg className="project-icon custom-svg" viewBox="0 0 192 192" fill="none">
                    <path d="M27.55 22v45.33h45.33v23.12h-22.2V170h22.2v-34.23h46.24V170h22.21V90.45h-22.21V67.33h45.33V22h-45.33v45.33H72.88V22H27.55z" stroke="white" strokeWidth="12" fill="none" />
                  </svg>
                ) : project.image === "laundry-icon" ? (
                  <svg className="project-icon custom-svg" viewBox="0 0 24 24" fill="none">
                    <path d="M18 4H15C15 4.39397 14.9224 4.78407 14.7716 5.14805C14.6209 5.51203 14.3999 5.84274 14.1213 6.12132C13.8427 6.3999 13.512 6.62087 13.1481 6.77164C12.7841 6.9224 12.394 7 12 7C11.606 7 11.2159 6.9224 10.8519 6.77164C10.488 6.62087 10.1573 6.3999 9.87868 6.12132C9.6001 5.84274 9.37913 5.51203 9.22836 5.14805C9.0776 4.78407 9 4.39397 9 4H6L3 7L3.5 12L6 10.5M21 7L20.5 12L18 10.5V20H6V14" stroke="white" strokeWidth="1.5" fill="none" />
                  </svg>
                ) : (
                  <span className={`project-icon ${project.id === 1 ? 'warning-icon' : ''}`}>{project.image}</span>
                )}
              </div>

              <div className="project-content">
                <div className="project-header">
                  <h3 className="project-title">{project.title}</h3>
                </div>

                <div className="project-categories">
                  <span className="project-category">{project.category}</span>
                  <span className="project-subcategory">{project.subcategory}</span>
                  {project.status && (
                    <span className="project-status">{project.status}</span>
                  )}
                </div>

                <p className="project-description">{project.description}</p>

                <div className="project-technologies">
                  {project.technologies.map(tech => (
                    <span key={tech} className="tech-tag">{tech}</span>
                  ))}
                </div>

                {project.learnMore && (
                  <div className="project-learn-more">
                    <button
                      onClick={() => setExpandedProject(project.id)}
                      className="btn btn-secondary learn-more-btn"
                    >
                      Learn More
                    </button>
                  </div>
                )}

                {project.hasNewVersion && (
                  <div className="project-new-version">
                    <button
                      onClick={() => scrollToNewVersion(project.newVersionId)}
                      className="btn btn-primary new-version-btn"
                    >
                      See New Version
                    </button>
                  </div>
                )}

                {/* Project links */}
                {(project.id === 1 || project.id === 3 || project.id === 4 || project.id === 7 || project.id === 8 || project.id === 9 || project.id === 10 || project.id === 11 || project.id === 12 || project.id === 13) && (
                  <div className="project-links">
                    {project.githubUrl && (
                      <a
                        href={project.githubUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link github-link"
                      >
                        <span>📁</span> View Code
                      </a>
                    )}
                    {project.liveUrl && (
                      <a
                        href={project.liveUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link live-link"
                      >
                        <span>🌐</span> {project.id === 1 ? 'View Demo' : project.id === 3 ? 'View Demo' : project.id === 4 ? 'View Demo' : 'View Site'}
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </section>

        {filteredProjects.length === 0 && (
          <div className="no-projects">
            <p>No projects found in this category.</p>
          </div>
        )}

        <section className="projects-cta">
          <div className="cta-content">
            <h2>Want to discuss what I could bring to your team?</h2>
            <p>Let's Talk!</p>
            <div className="contact-info">
              <div className="contact-item">
                <strong>Email:</strong>
                <a href="mailto:JacobW@segotw.com">JacobW@segotw.com</a>
              </div>
              <div className="contact-item">
                <strong>Phone:</strong>
                <a href="tel:+13149399335">+1 (314) 939-9335</a>
              </div>
            </div>
            <div className="cta-buttons">
              <a href="/experience" className="btn btn-primary">
                View Experience
              </a>
              <a href="/skills" className="btn btn-secondary">
                See My Skills
              </a>
            </div>
          </div>
        </section>
      </div>

      {/* Learn More Modal */}
      {expandedProject && (() => {
        const project = projects.find(p => p.id === expandedProject);
        return project && project.learnMore ? (
          <div className="modal-overlay" onClick={() => setExpandedProject(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>{project.learnMore.title}</h3>
                <button
                  className="modal-close"
                  onClick={() => setExpandedProject(null)}
                >
                  ×
                </button>
              </div>

              <div className="modal-body">
                <p className="modal-description">{project.learnMore.description}</p>

                {project.learnMore.liveDemo && (
                  <div className="modal-section">
                    <h4>🌐 View Demo:</h4>
                    <div className="live-demo-container">
                      <a
                        href={project.learnMore.liveDemo.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary live-demo-btn"
                      >
                        <span>🌐</span> Try View Demo
                      </a>
                      <div className="demo-note login-credentials">
                        <div className="credentials-box">
                          <h5>🔐 Admin Login Credentials:</h5>
                          <div className="credentials-info">
                            <div className="credential-item">
                              <strong>Username:</strong> <code>admin</code>
                            </div>
                            <div className="credential-item">
                              <strong>Password:</strong> <code>P@ssw0rd</code>
                            </div>
                          </div>
                          <div className="credentials-note">
                            <em>{project.learnMore.liveDemo.note}</em>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {project.learnMore.videoUrl && (
                  <div className="modal-section">
                    <h4>Demo Video:</h4>
                    <div className="video-container">
                      {project.learnMore.videoUrl.includes('youtube.com') || project.learnMore.videoUrl.includes('vimeo.com') ? (
                        <iframe
                          src={project.learnMore.videoUrl}
                          title="LaundroDrop 2.0 Demo"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <video
                          src={project.learnMore.videoUrl}
                          title="LaundroDrop 2.0 Demo"
                          controls
                          preload="metadata"
                        >
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </div>
                  </div>
                )}

                <div className="modal-section">
                  <h4>Key Features:</h4>
                  <ul>
                    {project.learnMore.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>

                {project.learnMore.coreFeatures && (
                  <div className="modal-section">
                    <h4>Core System Features:</h4>

                    <div className="feature-subsection">
                      <h5>🔐 Authentication & Authorization</h5>
                      <ul>
                        {project.learnMore.coreFeatures.authentication.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>👥 User Management</h5>
                      <ul>
                        {project.learnMore.coreFeatures.userManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>📦 Product Management</h5>
                      <ul>
                        {project.learnMore.coreFeatures.productManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>👨‍💼 Customer Management</h5>
                      <ul>
                        {project.learnMore.coreFeatures.customerManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>🚨 Incident Management</h5>
                      <ul>
                        {project.learnMore.coreFeatures.incidentManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>🔧 Technician Tools</h5>
                      <ul>
                        {project.learnMore.coreFeatures.technicianTools.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.securityFeatures && (
                  <div className="modal-section">
                    <h4>🛡️ Security Features:</h4>
                    <ul>
                      {project.learnMore.securityFeatures.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {project.learnMore.architecture && (
                  <div className="modal-section">
                    <h4>🏗️ Architecture & Tech Stack:</h4>

                    <div className="feature-subsection">
                      <h5>Backend (Node.js/Express)</h5>
                      <ul>
                        {project.learnMore.architecture.backend.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Frontend (React.js)</h5>
                      <ul>
                        {project.learnMore.architecture.frontend.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.authentication && (
                  <div className="modal-section">
                    <h4>🔐 Authentication & Authorization System:</h4>

                    <div className="feature-subsection">
                      <h5>User Management</h5>
                      <ul>
                        {project.learnMore.authentication.userManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Security Features</h5>
                      <ul>
                        {project.learnMore.authentication.securityFeatures.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.bugTracking && (
                  <div className="modal-section">
                    <h4>🐛 Bug Tracking System:</h4>

                    <div className="feature-subsection">
                      <h5>Core Bug Management</h5>
                      <ul>
                        {project.learnMore.bugTracking.coreManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Advanced Features</h5>
                      <ul>
                        {project.learnMore.bugTracking.advancedFeatures.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.communication && (
                  <div className="modal-section">
                    <h4>💬 Communication & Collaboration:</h4>

                    <div className="feature-subsection">
                      <h5>Comment System</h5>
                      <ul>
                        {project.learnMore.communication.commentSystem.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Live Chat System</h5>
                      <ul>
                        {project.learnMore.communication.liveChat.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.testing && (
                  <div className="modal-section">
                    <h4>🧪 Testing & Quality Assurance:</h4>
                    <ul>
                      {project.learnMore.testing.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {project.learnMore.dataManagement && (
                  <div className="modal-section">
                    <h4>📊 Data Management & Analytics:</h4>

                    <div className="feature-subsection">
                      <h5>Database Collections</h5>
                      <ul>
                        {project.learnMore.dataManagement.databaseCollections.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Advanced Database Features</h5>
                      <ul>
                        {project.learnMore.dataManagement.advancedFeatures.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.userInterface && (
                  <div className="modal-section">
                    <h4>🎨 User Interface & Experience:</h4>

                    <div className="feature-subsection">
                      <h5>Responsive Design</h5>
                      <ul>
                        {project.learnMore.userInterface.responsiveDesign.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Component Architecture</h5>
                      <ul>
                        {project.learnMore.userInterface.components.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Pages & Routes</h5>
                      <ul>
                        {project.learnMore.userInterface.pages.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.development && (
                  <div className="modal-section">
                    <h4>🔧 Development & Deployment:</h4>

                    <div className="feature-subsection">
                      <h5>Development Features</h5>
                      <ul>
                        {project.learnMore.development.features.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Production Ready</h5>
                      <ul>
                        {project.learnMore.development.production.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.achievements && (
                  <div className="modal-section">
                    <h4>🚀 Key Technical Achievements:</h4>
                    <ul>
                      {project.learnMore.achievements.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {project.learnMore.portfolioHighlights && (
                  <div className="modal-section">
                    <h4>📈 Portfolio Highlights:</h4>
                    <ul>
                      {project.learnMore.portfolioHighlights.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {project.learnMore.coreBusinessFeatures && (
                  <div className="modal-section">
                    <h4>Core Business Features:</h4>

                    <div className="feature-subsection">
                      <h5>Order Management System</h5>
                      <ul>
                        {project.learnMore.coreBusinessFeatures.orderManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Customer Management</h5>
                      <ul>
                        {project.learnMore.coreBusinessFeatures.customerManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Item & Service Management</h5>
                      <ul>
                        {project.learnMore.coreBusinessFeatures.itemServiceManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Payment Processing System</h5>
                      <h6>Multi-Payment Type Support</h6>
                      <ul>
                        {project.learnMore.coreBusinessFeatures.paymentProcessing.multiPaymentSupport.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                      <h6>Payment Management</h6>
                      <ul>
                        {project.learnMore.coreBusinessFeatures.paymentProcessing.paymentManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Printing & Receipt System</h5>
                      <h6>Advanced Printing Capabilities</h6>
                      <ul>
                        {project.learnMore.coreBusinessFeatures.printingReceiptSystem.advancedPrinting.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                      <h6>Receipt Customization</h6>
                      <ul>
                        {project.learnMore.coreBusinessFeatures.printingReceiptSystem.receiptCustomization.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.administrativeFeatures && (
                  <div className="modal-section">
                    <h4>Administrative Features:</h4>

                    <div className="feature-subsection">
                      <h5>Employee Management</h5>
                      <ul>
                        {project.learnMore.administrativeFeatures.employeeManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Settings Management</h5>
                      <ul>
                        {project.learnMore.administrativeFeatures.settingsManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.dataManagementSecurity && (
                  <div className="modal-section">
                    <h4>Data Management & Security:</h4>

                    <div className="feature-subsection">
                      <h5>Comprehensive Audit System</h5>
                      <ul>
                        {project.learnMore.dataManagementSecurity.auditSystem.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Backup & Recovery System</h5>
                      <ul>
                        {project.learnMore.dataManagementSecurity.backupRecovery.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.technicalArchitecture && (
                  <div className="modal-section">
                    <h4>Technical Architecture:</h4>

                    <div className="feature-subsection">
                      <h5>Modern .NET MAUI Framework</h5>
                      <ul>
                        {project.learnMore.technicalArchitecture.modernFramework.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Database & Data Management</h5>
                      <ul>
                        {project.learnMore.technicalArchitecture.databaseManagement.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Real-time Features</h5>
                      <ul>
                        {project.learnMore.technicalArchitecture.realTimeFeatures.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.communicationNotifications && (
                  <div className="modal-section">
                    <h4>Communication & Notifications:</h4>

                    <div className="feature-subsection">
                      <h5>SMS Integration</h5>
                      <ul>
                        {project.learnMore.communicationNotifications.smsIntegration.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>User Interface Enhancements</h5>
                      <ul>
                        {project.learnMore.communicationNotifications.userInterfaceEnhancements.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {project.learnMore.advancedFeatures && (
                  <div className="modal-section">
                    <h4>Advanced Features:</h4>

                    <div className="feature-subsection">
                      <h5>Order Caching System</h5>
                      <ul>
                        {project.learnMore.advancedFeatures.orderCaching.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Search & Filtering</h5>
                      <ul>
                        {project.learnMore.advancedFeatures.searchFiltering.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="feature-subsection">
                      <h5>Data Export & Reporting</h5>
                      <ul>
                        {project.learnMore.advancedFeatures.dataExportReporting.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                <div className="modal-section">
                  <h4>Background:</h4>
                  <p>{project.learnMore.background}</p>
                </div>

                <div className="modal-section">
                  <h4>Technical Details:</h4>
                  <p>{project.learnMore.technicalDetails}</p>
                </div>
              </div>
            </div>
          </div>
        ) : null;
      })()}
    </div>
  );
};

export default Projects; 